// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tooltipStyling .ant-tooltip-arrow-content::before {
  background: #c11b2f !important;
}
.tooltipStyling .ant-tooltip-arrow::before {
  background-color: #4caf50;
}
.tooltipStyling .ant-tooltip-inner {
  background-color: #4caf50 !important;
}
.tooltipStyling .fa-circle-info {
  color: #009043;
  font-size: 14px;
}
.tooltipStyling.productTooltip {
  min-width: 470px;
  max-width: 600px;
  z-index: 99999 !important;
}
.tooltipStyling.productTooltip .ant-tooltip-arrow::before {
  background-color: #c11b2f;
}
.tooltipStyling.productTooltip .ant-tooltip-inner {
  background-color: #ffffff !important;
  color: unset !important;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper {
  border: none;
  box-shadow: none;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .productBox {
  width: 100%;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .productBox .productName h4 {
  margin: 0;
  margin-bottom: 10px;
  word-break: break-word;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .productBox .productId {
  display: flex;
  gap: 20px;
  justify-content: space-between;
  border: 1px solid #edf2f7;
  padding: 10px;
  border-radius: 11px;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .productBox .productId h5 {
  color: #8f8f8f;
  font-family: Poppins;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  /* 142.857% */
  padding: 0;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description {
  margin-top: 20px;
  max-height: 150px;
  overflow-y: auto;
  overflow-x: hidden;
  overflow-y: overlay;
  color: #a3a3a3;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  word-break: auto-phrase;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description p:empty {
  display: none;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h1,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h2,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h3,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h4,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h5,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h6,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description p {
  overflow-y: overlay;
  color: #a3a3a3;
  font-size: 14px;
  font-weight: 400;
  width: 100%;
  word-break: auto-phrase;
  margin: 0;
  padding-bottom: 5px;
  line-height: 1.5;
}
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h1:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h2:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h3:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h4:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h5:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description h6:empty,
.tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description p:empty {
  display: none;
}
.tooltipStyling.red .ant-tooltip-inner {
  background-color: #c11b2f !important;
}
.tooltipStyling.red .ant-tooltip-arrow::before {
  background-color: #c11b2f;
}
span.tooltipStyling {
  display: inline-block;
  margin-left: 4px;
  font-weight: 600;
  font-size: 14px;
  line-height: 1.5;
}
@media (min-width: 1281px) and (max-width: 1599px) {
  .tooltipStyling.productTooltip {
    max-width: 500px;
  }
  .tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description p {
    font-size: 12px;
  }
}
@media (min-width: 1025px) and (max-width: 1280px) {
  .tooltipStyling.productTooltip {
    min-width: 420px;
    max-width: 500px;
  }
  .tooltipStyling.productTooltip .ant-tooltip-inner .wrapper .description p {
    font-size: 12px;
  }
}
@media (min-width: 481px) and (max-width: 767px) {
  .tooltipStyling .ant-tooltip-inner {
    width: 360px;
  }
}
@media (min-width: 280px) and (max-width: 480px) {
  .tooltipStyling .ant-tooltip-inner {
    width: 260px;
  }
  .tooltipStyling .ant-tooltip-inner .wrapper .productBox .productId {
    flex-direction: column;
    gap: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/UiComponents/CustomTooltip/CustomTooltip.less"],"names":[],"mappings":"AACA;EAEI,8BAAA;AADJ;AAKI;EACE,yBAAA;AAHN;AAJA;EAYI,oCAAA;AALJ;AAPA;EAgBI,cAAA;EACA,eAAA;AANJ;AASE;EACE,gBAAA;EACA,gBAAA;EACA,yBAAA;AAPJ;AASM;EACE,yBAAA;AAPR;AACE;EAUI,oCAAA;EACA,uBAAA;AARN;AAHE;EAaM,YAAA;EACA,gBAAA;AAPR;AAPE;EAgBQ,WAAA;AANV;AAVE;EAmBY,SAAA;EACA,mBAAA;EACA,sBAAA;AANd;AAfE;EAyBU,aAAA;EACA,SAAA;EACA,8BAAA;EACA,yBAAA;EACA,aAAA;EACA,mBAAA;AAPZ;AAvBE;EAgCY,cAAA;EACA,oBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;EANZ,aAAa;EAOD,UAAA;AALd;AAjCE;EA2CQ,gBAAA;EACA,iBAAA;EAEA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;AARV;AAgBY;EACE,aAAA;AAdd;AAhDE;;;;;;;EAwEU,mBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;AAfZ;AAgBY;;;;;;;EACE,aAAA;AARd;AAeE;EAEI,oCAAA;AAdN;AAkBM;EACE,yBAAA;AAhBR;AAsBA;EACE,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,gBAAA;AApBF;AAiCA;EAEI;IACE,gBAAA;EAhCJ;EA+BE;IAMU,eAAA;EAlCZ;AACF;AA4CA;EAEI;IACE,gBAAA;IACA,gBAAA;EA3CJ;EAyCE;IAOU,eAAA;EA7CZ;AACF;AA+DA;EACE;IAEI,YAAA;EA9DJ;AACF;AAkEA;EACE;IAEI,YAAA;EAjEJ;EA+DA;IAMU,sBAAA;IACA,MAAA;EAlEV;AACF","sourcesContent":["@import url(\"../../../assets/Styles/variables.less\");\n.tooltipStyling {\n  .ant-tooltip-arrow-content::before {\n    background: @primary-color !important;\n  }\n\n  .ant-tooltip-arrow {\n    &::before {\n      background-color: @greenBg;\n    }\n  }\n\n  .ant-tooltip-inner {\n    background-color: @greenBg !important;\n  }\n\n  .fa-circle-info {\n    color: #009043;\n    font-size: 14px;\n  }\n\n  &.productTooltip {\n    min-width: 470px;\n    max-width: 600px;\n    z-index: 99999 !important;\n    .ant-tooltip-arrow {\n      &::before {\n        background-color: @primary-color;\n      }\n    }\n    .ant-tooltip-inner {\n      background-color: @white-color !important;\n      color: unset !important;\n      .wrapper {\n        border: none;\n        box-shadow: none;\n        .productBox {\n          width: 100%;\n          .productName {\n            h4 {\n              margin: 0;\n              margin-bottom: 10px;\n              word-break: break-word;\n            }\n          }\n          .productId {\n            display: flex;\n            gap: 20px;\n            justify-content: space-between;\n            border: 1px solid #edf2f7;\n            padding: 10px;\n            border-radius: 11px;\n            h5 {\n              color: #8f8f8f;\n              font-family: Poppins;\n              font-size: 14px;\n              font-style: normal;\n              font-weight: 400;\n              line-height: 20px; /* 142.857% */\n              padding: 0;\n            }\n          }\n        }\n        .description {\n          margin-top: 20px;\n          max-height: 150px;\n          width: 100%;\n          overflow-y: auto;\n          overflow-x: hidden;\n          overflow-y: overlay;\n          color: #a3a3a3;\n          font-size: 14px;\n          font-weight: 400;\n          width: 100%;\n          word-break: auto-phrase;\n          p {\n            // overflow-y: overlay;\n            // color: #a3a3a3;\n            // font-size: 14px;\n            // font-weight: 400;\n            // width: 100%;\n            // word-break: auto-phrase;\n            &:empty {\n              display: none;\n            }\n          }\n          h1,\n          h2,\n          h3,\n          h4,\n          h5,\n          h6,\n          p {\n            overflow-y: overlay;\n            color: #a3a3a3;\n            font-size: 14px;\n            font-weight: 400;\n            width: 100%;\n            word-break: auto-phrase;\n            margin: 0;\n            padding-bottom: 5px;\n            line-height: 1.5;\n            &:empty {\n              display: none;\n            }\n          }\n        }\n      }\n    }\n  }\n  &.red {\n    .ant-tooltip-inner {\n      background-color: @primary-color !important;\n    }\n\n    .ant-tooltip-arrow {\n      &::before {\n        background-color: @primary-color;\n      }\n    }\n  }\n}\n\nspan.tooltipStyling {\n  display: inline-block;\n  margin-left: 4px;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n// MEDIA QUERY START\n\n// ##Device = HD Desktops\n// ##Screen = 1600px to higher resolution desktops\n\n@media screen and (min-width: 1600px) {\n} //  Dont delete this bracket!\n\n// ##Device = Desktops\n// ##Screen = 1281px to higher resolution desktops\n@media (min-width: 1281px) and (max-width: 1599px) {\n  .tooltipStyling {\n    &.productTooltip {\n      max-width: 500px;\n      .ant-tooltip-inner {\n        .wrapper {\n          .description {\n            p {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n} //  Dont delete this bracket!\n\n// ##Device = Laptops, Desktops\n// ##Screen = B/w 1025px to 1280px\n@media (min-width: 1025px) and (max-width: 1280px) {\n  .tooltipStyling {\n    &.productTooltip {\n      min-width: 420px;\n      max-width: 500px;\n      .ant-tooltip-inner {\n        .wrapper {\n          .description {\n            p {\n              font-size: 12px;\n            }\n          }\n        }\n      }\n    }\n  }\n} //  1025px to 1280px (Laptops, Desktops) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (landscape)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {\n} //  768px to 1024px (landscape) Dont delete this bracket!\n\n// ##Device = Tablets, Ipads (portrait)\n// ##Screen = B/w 768px to 1024px\n@media (min-width: 768px) and (max-width: 1024px) {\n} //  768px to 1024px (portrait) Dont delete this bracket!\n\n@media (min-width: 481px) and (max-width: 767px) {\n  .tooltipStyling {\n    .ant-tooltip-inner {\n      width: 360px;\n    }\n  }\n}\n\n@media (min-width: 280px) and (max-width: 480px) {\n  .tooltipStyling {\n    .ant-tooltip-inner {\n      width: 260px;\n      .wrapper {\n        .productBox {\n          .productId {\n            flex-direction: column;\n            gap: 0;\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
